import { Fragment } from "react"

import { Button } from "@/components/ui/button"

import { STEPS } from "../../config/landing-content"
import { SectionTitle } from "../section-title"

interface HowItWorksSectionProps {
  onAction: () => void
}

export function HowItWorksSection({ onAction }: HowItWorksSectionProps) {
  return (
    <section data-slot="how-it-works-section" className="flex flex-col gap-4 px-4">
      <SectionTitle>How Live Palmistry Works</SectionTitle>

      <div className="flex w-full flex-col items-start justify-center">
        {STEPS.map((step, i) => (
          <Fragment key={step.title}>
            <div className="flex w-full items-center gap-3 overflow-hidden rounded-[16px]">
              <div className="flex items-center self-stretch">
                <div className="flex h-full w-10 items-center justify-center rounded-full bg-main-purple/10 px-2 py-3">
                  <span className="font-display text-[20px] font-medium text-main-purple">
                    {i + 1}
                  </span>
                </div>
              </div>
              <div className="flex min-w-0 flex-1 flex-col justify-center gap-1 py-2">
                <h3 className="font-display text-base font-medium text-purple-light">
                  {step.title}
                </h3>
                <p className="text-sm leading-snug text-purple-light/70">{step.subtitle}</p>
              </div>
            </div>
            {i < STEPS.length - 1 && (
              <div className="flex h-3 w-10 items-center justify-center">
                <div className="h-full w-px bg-main-purple" />
              </div>
            )}
          </Fragment>
        ))}
      </div>

      <Button variant="gradient" size="xl" onClick={onAction} className="mt-2">
        Get My Insights
      </Button>
    </section>
  )
}
